import React from 'react';
export function MaximizeIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5a1 1 0 011-1h18a1 1 0 011 1v14a1 1 0 01-1 1H3a1 1 0 01-1-1V5zm2 1v12h16V6H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10h3a1 1 0 100-2H7.005C6.45 8 6 8.45 6 9.005V13a1 1 0 102 0v-3zM16 14h-3a1 1 0 100 2h3.995C17.55 16 18 15.55 18 14.995V11a1 1 0 10-2 0v3z"
  }));
}